import { FooterBase } from "@Base/Site/FooterBase";

export class Footer extends FooterBase
{
	constructor()
	{
		super();
		this.Initialize();
	}

	public Initialize(): void
	{
		super.Initialize();
	};
}